import React from 'react';
import { faqCategories } from '../../../mocks/faqData';

interface CategoryTabsProps {
  categories: string[];
  selectedCategory: string;
  onCategoryChange: (id: string) => void;
}

export default function CategoryTabs({
  selectedCategory,
  onCategoryChange,
}: CategoryTabsProps) {
  return (
    <div className="sticky top-[60px] z-30 bg-white/95 backdrop-blur-sm border-b border-gray-100 py-3">
      <div className="max-w-5xl mx-auto px-4 sm:px-6">
        <div
          role="group"
          aria-label="Filter FAQ by category"
          className="flex items-center gap-2 overflow-x-auto pb-1 scrollbar-hide"
        >
          {/* "All" button */}
          <button
            type="button"
            onClick={() => onCategoryChange('all')}
            aria-pressed={selectedCategory === 'all'}
            className={`flex items-center gap-1.5 px-4 py-2 min-h-[44px] rounded-full text-sm font-medium whitespace-nowrap cursor-pointer transition-all duration-200 ${
              selectedCategory === 'all'
                ? 'bg-teal-600 text-white shadow-sm'
                : 'bg-gray-100 text-[#374151] hover:bg-gray-200'
            }`}
          >
            <i className="ri-list-check w-4 h-4 flex items-center justify-center" aria-hidden="true"></i>
            All Questions
          </button>

          {/* Category buttons */}
          {faqCategories.map((cat) => (
            <button
              key={cat.id}
              type="button"
              onClick={() => onCategoryChange(cat.id)}
              aria-pressed={selectedCategory === cat.id}
              className={`flex items-center gap-1.5 px-4 py-2 min-h-[44px] rounded-full text-sm font-medium whitespace-nowrap cursor-pointer transition-all duration-200 ${
                selectedCategory === cat.id
                  ? 'bg-teal-600 text-white shadow-sm'
                  : 'bg-gray-100 text-[#374151] hover:bg-gray-200'
              }`}
            >
              <i className={`${cat.icon} w-4 h-4 flex items-center justify-center`} aria-hidden="true"></i>
              {cat.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
